import NewsListContainer from './components/List/NewsListContainer';
import NewsDetailsContainer from './components/Details/NewsDetailsContainer';
import SnackbarLastNews from './components/SnackbarLastNews';
import './assets/scss/main.css';

export {NewsDetailsContainer, SnackbarLastNews};

export default NewsListContainer;


// WEBPACK FOOTER //
// ./src/features/News/index.js